import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { Chapter } from '@/types/comic';

export default function ChapterList({
  comicId,
  chapters,
}: {
  comicId: string;
  chapters: Chapter[];
}) {
  const [expanded, setExpanded] = useState(false);
  const limit = 24;
  const shown = expanded ? chapters : chapters.slice(0, limit);

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <i className="ri-list-check-2 text-primary-500" />
          章节目录
        </h2>
        <span className="text-xs text-foreground-500">共 {chapters.length} 话 · 倒序排列</span>
      </div>

      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
        {shown.map((ch) => (
          <Link
            key={ch.id}
            to={`/read/${comicId}/${ch.id}`}
            className="flex items-center justify-between gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
          >
            <span className="truncate">{ch.title}</span>
            <span className="shrink-0 text-[11px] text-foreground-400">{ch.updatedAt.slice(5)}</span>
          </Link>
        ))}
      </div>

      {chapters.length > limit && (
        <div className="mt-4 flex justify-center">
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            className="flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
          >
            {expanded ? '收起目录' : `展开全部 ${chapters.length} 话`}
            <i className={expanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
          </button>
        </div>
      )}
    </div>
  );
}